import React, {useEffect, useState} from 'react';
import {Card, Dropdown, Grid} from 'semantic-ui-react';
import '../styles.scss';
import FloatingSummaryTable from './floatingSummaryTable';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {advanceReserveList} from '../../constants/advanceReserveListDivided';
import {daysDepositList} from '../../constants/daysDepositList';
import {mapListToDropdownList} from '../../../common/components/commercialTable/utils';
import NotPriorizedModal from '../commons/notpriorizedModal/notPriorizedModal';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {UserGroup} from '../../constants/userGroup';

const SummaryScreen = ({
  currentFlUserGroup,
  dataWasShown,
  dealerId,
  fetchDealers,
  fetchNotPriorizedVehicles,
  fetchFloatingSummary,
  floatingSummaryData,
  isNotpriorizedModalOpen,
  isUserTde,
  listDealers,
  loading,
  notPriorizedVehicles,
  navigateTo,
  permissions,
  setIsNotpriorizedModalOpen,
  setCurrentFlUserGroup,
  setDataWasShown,
}) => {
  const [filters, setFilters] = useState({
    'master': '',
    'dealer': '',
    'reservationAdvance': '',
    'antiquity': '',
  });

  const [listMappedDealers, setListMappedDealers] = useState([]);
  const [listModels, setListModels] = useState([]);

  useEffect(() => {
    if (
      !hasAccessPermission(permissions, resources.FloatingInventory, scopes.See)
    ) {
      navigateTo(paths.AccessDenied);
    }
    if (isUserTde) {
      if (hasAccessPermission(permissions, resources.FloatingInventory, scopes.Edit) &&
        hasAccessPermission(permissions, resources.FloatingInventory, scopes.See) &&
        hasAccessPermission(permissions, resources.FloatingInventory, scopes.Create)) {
        setCurrentFlUserGroup(UserGroup.tdeUser);
      } else if (hasAccessPermission(permissions, resources.FloatingInventory, scopes.See)) {
        setCurrentFlUserGroup(UserGroup.adviserDealer);
      }
    } else if (
      hasAccessPermission(permissions, resources.FloatingInventory, scopes.Edit) &&
      hasAccessPermission(permissions, resources.FloatingInventory, scopes.See) &&
      hasAccessPermission(permissions, resources.FloatingInventory, scopes.Create)
    ) {
      setCurrentFlUserGroup(UserGroup.coachDealer);
    } else {
      setCurrentFlUserGroup(UserGroup.adviserDealer);
    }
  }, []);
  
  useEffect(() => {
    fetchDealers('float');
  }, []);

  useEffect(() => {
    fetchNotPriorizedVehicles(dealerId);
  }, []);

  useEffect(() => {
    if (
      notPriorizedVehicles.length &&
      currentFlUserGroup === UserGroup.coachDealer &&
      !dataWasShown) {
      setIsNotpriorizedModalOpen(true);
      setDataWasShown(false);
    } else {
      setIsNotpriorizedModalOpen(false);
    }
  }, [notPriorizedVehicles, currentFlUserGroup]);

  useEffect(() => {
    fetchFloatingSummary(filters);
  }, [filters]);


  useEffect(() => {
    if (floatingSummaryData.length > listModels.length) {
      setListModels(mapListToDropdownList(floatingSummaryData, {
        'keys': ['master', 'sfx'],
        'values': ['master', 'sfx'],
        'texts': ['description'],
      }, true, '/'));
    }
  }, [floatingSummaryData]);


  useEffect(() => {
    setListMappedDealers(mapListToDropdownList(listDealers, {
      'keys': ['identification'],
      'values': ['identification'],
      'texts': ['name'],
    }, true));
  }, [listDealers]);

  const handleShowOrders = (property, value) => {
    setFilters({...filters, [property]: value});
  };

  return (
    <>
      <Card className='small-title-container'>
        <div className="title-bar center-vertical w-100">
          <div className="title center-vertical ">
            <h3>
              {'Administración de Inventario Flotante'}
            </h3>
          </div>
        </div>
      </Card>
      <Card fluid className="card-wrapper-auto">
        <div className="w-100 filters-inventory">
          <Grid className="w-100">
            <Grid.Row columns={4}>
              <Grid.Column>
                <Grid.Column width={3}>
                  <h4>MODELO:</h4>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Dropdown
                    placeholder="TODOS"
                    fluid
                    search
                    selection
                    value={filters.master}
                    onChange={(e, {value}) => handleShowOrders('master', value)}
                    options={listModels}
                    className='dropdown-main-inventory'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column>
                <Grid.Column width={7}>
                  <h4>DEALER:</h4>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Dropdown
                    placeholder="TODOS"
                    fluid
                    search
                    selection
                    value={filters.dealer}
                    onChange={(e, {value}) => handleShowOrders('dealer', value)}
                    options={listMappedDealers}
                    className='dropdown-main-inventory'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column>
                <Grid.Column width={7}>
                  <h4>AVANCE DE LA RESERVA:</h4>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Dropdown
                    placeholder="TODOS"
                    fluid
                    search
                    selection
                    value={filters.reservationAdvance}
                    onChange={(e, {value}) => handleShowOrders('reservationAdvance', value)}
                    options={advanceReserveList}
                    className='dropdown-main-inventory'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column>
                <Grid.Column width={7}>
                  <h4>ANTIGUEDAD:</h4>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Dropdown
                    placeholder="TODOS"
                    fluid
                    selection
                    value={filters.antiquity}
                    onChange={(e, {value}) => handleShowOrders('antiquity', value)}
                    options={daysDepositList}
                    className='dropdown-main-inventory'
                  />
                </Grid.Column>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <FloatingSummaryTable
          dataTable={floatingSummaryData}
          loading={loading}
          filters={filters}
        />
      </Card>
      <NotPriorizedModal
        isOpen={isNotpriorizedModalOpen}
        seIsOpen={setIsNotpriorizedModalOpen}
        data={notPriorizedVehicles}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'floatingSummaryData': state.floatingInventory.floatingSummaryData,
    'loading': state.floatingInventory.loading,
    'listDealers': state.dealer.list,
    'isNotpriorizedModalOpen': state.floatingInventory.isNotpriorizedModalOpen,
    'notPriorizedVehicles': state.floatingInventory.notPriorizedVehicles,
    'dealerId': state.session.dealerId,
    'permissions': state.session.permissions,
    'isUserTde': state.session.isUserFromTDE,
    'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
    'dataWasShown': state.floatingInventory.dataWasShown,
  };
};

const {
  fetchDealers,
  fetchNotPriorizedVehicles,
  fetchOrigins,
  fetchFloatingSummary,
  navigateTo,
  setCurrentFlUserGroup,
  setIsNotpriorizedModalOpen,
  setDataWasShown,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  fetchNotPriorizedVehicles,
  fetchOrigins,
  fetchFloatingSummary,
  navigateTo,
  setCurrentFlUserGroup,
  setIsNotpriorizedModalOpen,
  setDataWasShown,
})(SummaryScreen);
